<template>
  <div>
    <div class="mb-4">
      <Link class="group flex items-center py-3 font-bold font-2xl" href="/">
        <icon name="dashboard" class="mr-2 w-4 h-4" :class="isUrl('') ? 'fill-white' : 'fill-grey-100 group-hover:fill-white'" />
        <div :class="isUrl('') ? 'text-white' : 'text-grey-100 group-hover:text-white'">Онлайн-урок</div>
      </Link>
    </div>



  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'

export default {
  components: {
    Icon,
    Link,
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter((url) => currentUrl.startsWith(url)).length
    },
  },
}
</script>
